var colTracker = [];
/**
* Set appropriate spanning to any masonry item
*
* Get different properties we already set for the masonry, calculate
* height or spanning for any cell of the masonry grid based on its
* content-wrapper's height, the (row) gap of the grid, and the size
* of the implicit row tracks.
*
* @param item Object A brick/tile/cell inside the masonry
*/
function resizeMasonryItem(grid, item) {
  // this variable determines accuracy of masonry row gaps, they could differ up to this number of pixels
  // lower value - more uniform, but browsers have max grid rows to be aware of
  var rowHeight = 16;
  grid.style.rowGap = 0;

  // get index of shortest column
  var colIndex = colTracker.indexOf(Math.min(...colTracker));

  // calculate number of rows spanned by item
  var rowSpan = Math.ceil((item.getBoundingClientRect().height) / rowHeight);

  // set size and grid position of item
  item.style.height = `${rowSpan * rowHeight}px`;
  item.style.gridColumnStart = colIndex + 1;
  item.style.gridRowStart = colTracker[colIndex];

  // update height and rows of grid
  var gridHeightToEnd = ((colTracker[colIndex] + rowSpan) * rowHeight) + parseInt(window.getComputedStyle(grid).getPropertyValue("padding-top")) + parseInt(window.getComputedStyle(grid).getPropertyValue("padding-bottom"));
  grid.style.height = `${gridHeightToEnd}px`;
  grid.style.gridTemplateRows = `repeat(${colTracker[colIndex] + rowSpan}, ${rowHeight}px)`;

  // update column tracker with added rows plus gap
  colTracker[colIndex] += rowSpan + 2;
}

/**
* Apply spanning to all the masonry items
*
* Loop through all the items and apply the spanning to them using
* `resizeMasonryItem()` function.
*
* @uses resizeMasonryItem
*/
function resizeAllMasonryItems(selectors) {
  var grids = document.querySelectorAll(selectors);

  grids.forEach((grid) => {
    // reset column tracker and inline styles
    colTracker = [];
    grid.style.rowGap = null;
    grid.style.height = null;
    grid.style.gridTemplateRows = null;

    // get all grid items
    var allItems = grid.querySelectorAll(':scope > *');

    // reset item inline styles
    for (let i = 0; i < allItems.length; i++) {
      allItems[i].style.gridColumnStart = null;
      allItems[i].style.gridRowStart = null;
      allItems[i].style.height = null;
    }

    // get number of columns
    var colCount = window.getComputedStyle(grid).getPropertyValue("grid-template-columns").split(" ").length;

    // initiliase column tracker
    for (let i = 0; i < colCount; i++) {
      colTracker.push(1);
    }

    // loop items
    for (let i = 0; i < allItems.length; i++) {
      resizeMasonryItem(grid, allItems[i]);
    }
  });
}

// target elements
window.addEventListener('DOMContentLoaded', () => {
  resizeAllMasonryItems('.masonry-grid');
});

window.addEventListener('resize', () => {
  resizeAllMasonryItems('.masonry-grid');
});
